import React, { useEffect, useState } from "react";
import Select from "react-select";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { apiKey } from "../../../config/config";
import handleCSRF from "../../../config/CSRF";
import { toast } from "react-toastify";
import MessageCard from "../../../components/AdminCards/MessageCard";

function AddDealsForm() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const { id } = useParams();
  const [pageLoading, setPageLoading] = useState(false);
  const [mainCategories, setMainCategories] = useState([]);
  const [vat, setVat] = useState([]);
  const [items, setItems] = useState([]);
  const [formData, setFormData] = useState({
    code: "",
    name: "",
    name_arabic: "",
    category_id: "",
    description: "",
    sale_price: "",
    hunger_station_price: "",
    jahiz_price: "",
    tax_method: "",
    kot_print: "",
    vat_id: "",
  });
  const [dealPhoto, setDealPhoto] = useState(null);
  const [selectedItems, setSelectedItems] = useState([]);
  const [itemTotal, setItemTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const methodOptions = [
    { label: "Exclusive", value: "exclusive" },
    { label: "Inclusive", value: "inclusive" },
  ];

  const chooseOptions = [
    { label: "No", value: "no" },
    { label: "Yes", value: "yes" },
  ];

  const [selectedDeal, setSelectedDeal] = useState("No file chosen");

  const navigate = useNavigate();

  const handleItemSelect = (selectedOptions) => {
    setSelectedItems((prevSelectedIngredients) => {
      const newSelectedIngredients = selectedOptions.map((option) => {
        const existing = prevSelectedIngredients.find(
          (ing) => ing.value === option.value
        );
        return existing || { ...option, quantity: "1" }; // Keep existing quantity or initialize
      });
      return newSelectedIngredients;
    });
  };

  const handleQuantityChange = (index, value) => {
    setSelectedItems((prevItems) => {
      const updatedItems = [...prevItems];
      const item = updatedItems[index];
      const quantity = parseFloat(value) || 0;
      item.quantity = quantity;
      item.sale_price = quantity * item.item_price || item.item_price; // Assuming item.item_price is the base price of the item
      return updatedItems;
    });
  };

  const quantityComponent = (index) => (
    <div className="flex" key={index}>
      <input
        type="text"
        placeholder="Quantity"
        value={selectedItems[index]?.quantity || ""}
        onChange={(e) => handleQuantityChange(index, e.target.value)}
        className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline"
      />
    </div>
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    let formToSubmit = new FormData();

    formToSubmit.append("code", formData.code);
    formToSubmit.append("name", formData.name);
    formToSubmit.append("name_arabic", formData.name_arabic);
    formToSubmit.append("category_id", formData.category_id);
    formToSubmit.append("is_deal", "yes");
    formToSubmit.append("is_discount", formData.is_discount);
    formToSubmit.append("discount_amount", formData.discount_amount);
    formToSubmit.append("description", formData.description);
    formToSubmit.append("sale_price", formData.sale_price);
    formToSubmit.append("hunger_station_price", formData.hunger_station_price);
    formToSubmit.append("jahiz_price", formData.jahiz_price);
    formToSubmit.append("tax_method", formData.tax_method);
    formToSubmit.append("kot_print", formData.kot_print);
    formToSubmit.append("vat_id", formData.vat_id);
    formToSubmit.append("user_id", user?.user.id);
    formToSubmit.append("outlet_id", user?.user.outlet_id);
    formToSubmit.append("is_tax_fix", formData.is_tax_fix);
    if (dealPhoto) formToSubmit.append("photo", dealPhoto);

    selectedItems.forEach((item, index) => {
      formToSubmit.append(`deal_details[${index}][food_menu_id]`, item.item_id);
      formToSubmit.append(`deal_details[${index}][name]`, item.name);
      formToSubmit.append(`deal_details[${index}][name_arabic]`, item.name_arabic);
      formToSubmit.append(`deal_details[${index}][price]`, item.item_price);
      formToSubmit.append(`deal_details[${index}][qty]`, item.quantity);
    });

    const postData = (csrfToken) => {
      if (!id) {
        axios
          .post(`${apiKey}/api/rms/admin/create-deal`, formToSubmit, {
            headers: {
              Authorization: `Bearer ${user?.token}`,

              "Content-Type": "multipart/form-data",
            },
          })
          .then((res) => {
            toast.success("Success", {
              position: "bottom-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            navigate(-1);
          })
          .catch((err) => {
            toast.error(err.response.data.message, {
              position: "bottom-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
          })
          .finally(() => setLoading(false));
      } else {
        axios
          .post(`${apiKey}/api/rms/admin/edit-deal/${id}?_method=PUT`, formToSubmit, {
            headers: {
              Authorization: `Bearer ${user?.token}`,

              "Content-Type": "multipart/form-data",
            },
          })
          .then((res) => {
            toast.success("Success", {
              position: "bottom-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            navigate(-1);
          })
          .catch((err) => {
            toast.error(err.response.data.message, {
              position: "bottom-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
          })
          .finally(() => setLoading(false));
      }
    };

    handleCSRF(postData);
  };

  useEffect(() => {
    const total = selectedItems.reduce((n, item) => {
      const price = parseFloat(item.sale_price);
      return n + (isNaN(price) ? 0 : price);
    }, 0);
    setItemTotal(total);
  }, [selectedItems]);

  useEffect(() => {
    const fetchMainCat = (csrfToken) => {
      return axios.get(`${apiKey}/api/rms/admin/categories`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      });
    };

    const fetchVat = (csrfToken) => {
      return axios.get(`${apiKey}/api/rms/admin/vats`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      });
    };

    const fetchItems = (csrfToken) => {
      return axios.get(`${apiKey}/api/rms/admin/foodMenus`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      });
    };

    const fetchData = (csrfToken) => {
      Promise.all([
        fetchMainCat(csrfToken),
        fetchVat(csrfToken),
        fetchItems(csrfToken),
      ])
        .then(([mainCatResponse, vatResponse, itemsResponse]) => {
          const mappedCategories = mainCatResponse.data.map((item) => ({
            value: item.id,
            label: item.category_name,
          }));
          setMainCategories(mappedCategories);
          const mappedVat = vatResponse.data.map((item) => ({
            value: item.id,
            label: item.name,
          }));
          setVat(mappedVat);
          const mappedItems = itemsResponse.data.foodMenus.map((item) => ({
            value: item.id,
            item_id: item.id,
            label: item.name,
            name: item.name,
            name_arabic: item.name_arabic,
            sale_price: item.sale_price,
            item_price: item.sale_price,
          }));
          setItems(mappedItems);
        })
        .catch((err) => {
          setError(err.message);
          // console.log(err);
        });
    };

    handleCSRF(fetchData);
  }, [user?.token]);

  useEffect(() => {
    if (id) {
      setPageLoading(true);
      axios
        .get(`${apiKey}/api/rms/admin/foodMenus/${id}`, {
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
        })
        .then((res) => {
          setFormData(res.data);
          const mappedIng = JSON.parse(res.data?.deal_details || "[]")?.map((item) => ({
            item_id: item.food_menu_id,
            item_price: item.price,
            name: item.name,
            name_arabic: item.name_arabic,
            label: item.name,
            quantity: item.qty,
            sale_price: item.price,
            value: item.item_id,
          }));
          setSelectedItems(mappedIng);
        })
        .catch((err) => {
          setError(err.response?.data?.message || "Error occured");
        })
        .finally(() => {
          setPageLoading(false);
        });
    }
  }, [id, user?.token]);

  if (error) {
    return (
      <MessageCard error={error} />
    );
  }

  if (pageLoading) {
    return (
      <div className="absolute top-0 left-0 w-full h-full grid place-items-center">
        <img src="/assets/gif/dash2.gif" alt="" />
      </div>
    );
  }

  return (
    <main>
      <div className="relative my-16 flex flex-col min-w-0 break-words w-full mb-6 shadow-lg bg-white rounded-lg p-4 border-0">
        <div className="flex justify-between items-center mb-4">
          <div className="flex justify-between items-center mb-4">
            <h1 className="text-[#7B20C7] text-2xl">Add Deal</h1>
          </div>
        </div>
        <div className="w-full">
          <form action="" className="w-full" onSubmit={handleSubmit}>
            <div className="grid grid-cols-3 gap-x-8 gap-y-4">
              <label>
                <span className="text-[#7B20C7] text-sm mb-2 relative ">
                  Deal Name
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder="Name"
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                  />
                </div>
              </label>
              <label>
                <span className="text-[#7B20C7] text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                  Deal Name Arabic
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder=" Arabic Name"
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    name="name_arabic"
                    value={formData.name_arabic}
                    onChange={handleChange}
                  />
                </div>
              </label>
              <label>
                <span className="text-[#7B20C7] text-sm mb-2 relative ">
                  Code
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder="123"
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    name="code"
                    value={formData.code}
                    onChange={handleChange}
                  />
                </div>
              </label>

              <label>
                <span className="text-[#7B20C7] text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                  Category
                </span>
                <div className="mb-2 pt-0">
                  <Select
                    type="text"
                    className="placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    placeholder="Select"
                    options={mainCategories}
                    defaultValue={{
                      value: formData.category_id,
                      label: formData.category?.category_name,
                    }}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        category_id: e.value,
                      })
                    }
                  />
                </div>
              </label>

              <label>
                <span className="text-[#7B20C7] text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                  Item
                </span>
                <div className="mb-2 pt-0">
                  <Select
                    type="text"
                    className="placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    placeholder="Select"
                    isMulti
                    closeMenuOnSelect={false}
                    defaultValue={selectedItems}
                    options={items}
                    onChange={handleItemSelect}
                  />
                </div>
              </label>
              {/* <label></label> */}

              <div className="relative overflow-x-auto col-span-3">
                <table className="w-full text-sm text-left rtl:text-right">
                  <thead className="uppercase font-medium">
                    <tr>
                      <th className="px-6 py-3">Item</th>
                      <th className="px-6 py-3">Quantity</th>
                      <th className="px-6 py-3">Amount</th>
                      {/* <th className="px-6 py-3">Actions</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {selectedItems.map((item, index) => (
                      <tr key={index}>
                        <td className="px-6 py-1">{item.label}</td>
                        <td className="px-6 py-1">
                          {quantityComponent(index)}
                        </td>
                        <td className="px-6 py-1">{item.item_price}</td>
                        {/* <td className="px-6 py-1">
                        <button
                          type="button"
                          className="rounded-full border border-[#7b20c7] w-fit p-1"
                          onClick={() => {
                            const updatedIngredients = [...selectedIngredients];
                            updatedIngredients.splice(index, 1);
                            setSelectedItems(updatedIngredients);
                          }}
                        >
                          <FaTrash className="fill-[#7B20C7] w-4" />
                        </button>
                      </td> */}
                      </tr>
                    ))}
                  </tbody>
                  <tfoot>
                    <tr>
                      <td className="px-6 py-1">Total</td>
                      <td className="px-6 py-1"></td>
                      <td className="px-6 py-1">{itemTotal}</td>
                    </tr>
                  </tfoot>
                </table>
              </div>

              <label>
                <span className="text-[#7B20C7] text-sm mb-2 relative ">
                  Sale Price
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder="Sale Price"
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    name="sale_price"
                    value={formData.sale_price}
                    onChange={handleChange}
                  />
                </div>
              </label>
              <label>
                <span className="text-[#7B20C7] text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                  Hunger Station Price
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder=" Hunger Station Price"
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    name="hunger_station_price"
                    value={formData.hunger_station_price}
                    onChange={handleChange}
                  />
                </div>
              </label>
              <label>
                <span className="text-[#7B20C7] text-sm mb-2 relative ">
                  Jahiz Price
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder="Jahiz Price"
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    name="jahiz_price"
                    value={formData.jahiz_price}
                    onChange={handleChange}
                  />
                </div>
              </label>

              <label>
                <span className="text-[#7B20C7] text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                  Tax method
                </span>
                <div className="mb-2 pt-0">
                  <Select
                    type="text"
                    className=" placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    placeholder="Select"
                    options={methodOptions}
                    defaultValue={{
                      value: formData.tax_method,
                      label:
                        formData.tax_method === "inclusive"
                          ? "Inclusive"
                          : formData.tax_method === "exclusive"
                          ? "Exclusive"
                          : "",
                    }}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        tax_method: e.value,
                      })
                    }
                  />
                </div>
              </label>

              <label>
                <span className="text-[#7B20C7] text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                  Tax Type(VAT)
                </span>
                <div className="mb-2 pt-0">
                  <Select
                    type="text"
                    className=" placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    placeholder="Select"
                    options={vat}
                    defaultValue={{
                      value: formData.vat_id,
                      label: formData.vat?.name,
                    }}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        vat_id: e.value,
                      })
                    }
                  />
                </div>
              </label>
              <label>
                <span className="text-[#7B20C7] text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                  Kot Print
                </span>
                <div className="mb-2 pt-0">
                  <Select
                    type="text"
                    className="placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    placeholder="Select"
                    options={chooseOptions}
                    defaultValue={{
                      value: formData.kot_print,
                      label:
                        formData.kot_print === "no"
                          ? "No"
                          : formData.kot_print === "yes"
                          ? "Yes"
                          : "",
                    }}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        kot_print: e.value,
                      })
                    }
                  />
                </div>
              </label>

              <div className="pt-5">
                <div className="flex flex-row items-center">
                  <input
                    type="file"
                    id="banner-input"
                    onChange={(e) => {
                      setSelectedDeal(e.target.files[0].name);
                      setDealPhoto(e.target.files[0]);
                    }}
                    hidden
                  />
                  <label
                    htmlFor="banner-input"
                    className="block text-sm text-white mr-4 py-2 px-4 rounded-md border-0 font-semibold bg-[#7B20C7] cursor-pointer"
                  >
                    Choose File
                  </label>
                  <label className="text-sm text-slate-500">
                    {selectedDeal}
                  </label>
                </div>
              </div>

              <label>
                <span className="text-[#7B20C7] text-sm mb-2 relative ">
                  Description
                </span>
                <div className="mb-2 pt-0">
                  <textarea
                    type="text"
                    placeholder="Description"
                    className="p-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    name="description"
                    value={formData.description}
                    onChange={handleChange}
                  />
                </div>
              </label>
            </div>
            <span className="w-full bg-[#7B20C7] h-1 my-2 inline-block"></span>
            <div className="flex gap-2">
              <button
                className="bg-[#7B20C7] text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit relative"
                type="submit"
              >
                {loading && (
                  <span className="absolute top-0 left-0 w-full h-full py-1 px-3 bg-black bg-opacity-50">
                    <img
                      className="w-4 mx-auto"
                      src="https://i.gifer.com/ZKZx.gif"
                      alt=""
                    />
                  </span>
                )}
                Submit
              </button>
              <button
                className="bg-[#7B20C7] text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
                type="button"
                onClick={() => navigate(-1)}
              >
                Back
              </button>
            </div>
          </form>
        </div>
      </div>
    </main>
  );
}

export default AddDealsForm;
